<div class="container-fluid py-2 py-md-3 px-0">
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div>
      <h2 class="mb-0">Tavoli</h2>
    </div>
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <div class="btn-group" role="group" aria-label="Vista catalogo tavoli">
        <button
          type="button"
          class="btn"
          [class.btn-primary]="view() === 'list'"
          [class.btn-outline-primary]="view() !== 'list'"
          [attr.aria-pressed]="view() === 'list'"
          (click)="setView('list')"
        >
          <i class="bi bi-grid me-1" aria-hidden="true"></i>Lista
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-primary]="view() === 'map'"
          [class.btn-outline-primary]="view() !== 'map'"
          [attr.aria-pressed]="view() === 'map'"
          (click)="setView('map')"
        >
          <i class="bi bi-map me-1" aria-hidden="true"></i>Mappa
        </button>
      </div>
    </div>
  </div>

  @if (!isMineTables) {
    @if (!isAdvancedSearch()) {
      <div class="table-search-bar-container mb-4">
        <div class="row g-2 align-items-center">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text search-icon-addon">
                <i class="bi bi-search" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                class="form-control search-input"
                placeholder="Cerca tavoli per nome, gioco, evento, luogo, organizzazione..."
                [formControl]="searchControl"
                aria-label="Cerca tavoli"
              />
              @if (searchControl.value) {
                <button
                  class="btn btn-outline-secondary border-start-0"
                  type="button"
                  (click)="clearSearch()"
                  aria-label="Cancella ricerca"
                >
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="mb-4">
        <app-game-table-advanced-filter
          [allGameTables]="allGameTables"
          [includePast]="includePast()"
          [initialValues]="advancedFilters()"
          (filterChange)="onAdvancedFilterChange($event)"
          (includePastChange)="onIncludePastChange($event)"
          (resetFilter)="onAdvancedFilterReset()"
          (close)="closeAdvancedSearch()"
        ></app-game-table-advanced-filter>
      </div>
    }
  }

  @if (includePast() && !isMineTables) {
    <div class="alert alert-info mb-3 py-2 text-center" role="alert">
      <small>Stai visualizzando anche i tavoli con sessioni passate.</small>
    </div>
  }

  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
        <span class="visually-hidden">Caricamento tavoli in corso...</span>
      </div>
    </div>
  } @else if (view() === 'map') {
    @if (gameTables.length > 0) {
      <p class="text-muted small mb-2">
        {{ mappableCount() }} di {{ gameTables.length }} tavoli sulla mappa.
        @if (mappableCount() < gameTables.length) {
          Gli altri non hanno coordinate (si usa il luogo del tavolo o dell'evento associato).
        }
      </p>
    }
    <app-osm-map
      [markers]="mapMarkers()"
      ariaLabel="Mappa dei tavoli"
      emptyMessage="Nessun tavolo con coordinate. Si usa il luogo del tavolo o dell'evento associato."
    ></app-osm-map>
  } @else if (gameTables.length > 0) {
    <app-paginated-list [items]="gameTables" colClass="col-12 col-sm-6 col-md-4 col-lg-3" [pageSize]="8">
      <ng-template let-gameTable>
        <app-game-table-card
          [gameTable]="gameTable"
          [showTitle]="showTitle"
          [showDescription]="showDescription"
        >
        </app-game-table-card>
      </ng-template>
    </app-paginated-list>
  } @else {
    <div class="container-generic text-center">
      <p class="message-error">Nessun tavolo trovato</p>
    </div>
  }
</div>
